import { useEffect, useState } from 'react';

import useUser from 'hooks/useUser';
import DirectoryPersonInput from './DirectoryPersonInput';
import ManualPersonInput from './ManualPersonInput';

interface IPersonInputProps {
	value: string[];
	label: string;
	addLabel: string;
	disabled?: boolean;
	onChange: (value: string[]) => void;
}

export default function PersonInput(props: IPersonInputProps) {
	const { user } = useUser();
	const [useDirectory, setUseDirectory] = useState(false);

	useEffect(() => {
		if (user) {
			setUseDirectory(user.selected_company.has_user_directory);
		} else {
			setUseDirectory(false);
		}
	}, [user]);

	return useDirectory ? <DirectoryPersonInput {...props} /> : <ManualPersonInput {...props} />;
}
